import React from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';
import Slider from 'react-slick';

import { isPortrait } from '../../utils/size';

import arrowRight from '../../assets/images/fwd.png';
import arrowLeft from '../../assets/images/back.png';
import arrowRightSmall from '../../assets/images/fwd-small.png';
import arrowLeftSmall from '../../assets/images/back-small.png';

const fade = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const CarosuelContainer = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 100%;
    flex: 1;

    .slick-slider {
        position: relative;
        display: block;
        ${props => props.numActions === 2 && !isPortrait() && `width: 100%;`}
    }

    .slick-track {
        display: flex;
        flex: 1;
        margin-top: ${props => (props.isMultiDonation || props.isVolunteer ? 0 : 10)}px;
        @media (max-width: 30em) {
            margin-top: ${props =>
                props.isMultiDonation || props.isVolunteer || props.isActionChoice
                    ? 5
                    : 30}px;
        }
        ${props =>
            props.isActionChoice &&
            props.activeActionIndex === 0 &&
            'margin-left: -20px !important;'};
    }

    .slick-list {
        overflow: hidden;
        ${props => (props.isVolunteer && isPortrait() ? `` : `margin: 0 15px;`)};
        ${props => props.isActionChoice && `margin: 0;`};
    }

    .slick-arrow {
        position: absolute;
        background: transparent;
        border: none;
        outline: none;
        top: 0;
        z-index: 1;
        opacity: ${() => (isPortrait() ? 1 : 0)};
        height: 100%;
        width: auto;
        ${props =>
            props.hover && !isPortrait() && `animation: ${fade} 0.5s linear 1 forwards`};
    }

    .slick-prev {
        left: ${() => (isPortrait() ? -15 : -20)}px;
        &:before {
            content: url(${() => (isPortrait() ? arrowLeftSmall : arrowLeft)});
        }
    }

    .slick-next {
        right: ${() => (isPortrait() ? -15 : -25)}px;
        &:before {
            content: url(${() => (isPortrait() ? arrowRightSmall : arrowRight)});
        }
    }

    .slick-slide {
        background: none;
        text-align: left;

        > div {
            padding: ${props => (props.isVolunteer ? `0 12` : `0 6`)}px;
        }
    }

    .slick-dots {
        padding: 0;
        bottom: ${props =>
            (props.isMultiDonation || props.isVolunteer) && !isPortrait()
                ? `35px`
                : props.isVolunteer
                ? `unset`
                : '45px'};
        ${props =>
            props.numActions === 2 && !isPortrait() && `display: none !important;`};
        @media (min-width: 30em) {
            display: ${props =>
                props.isMultiDonation || props.isVolunteer ? 'inherit' : 'none'};
        }

        li {
            width: ${props =>
                props.numActions > 2
                    ? isPortrait() && props.numActions > 6
                        ? 23
                        : 40
                    : 80}px;
            height: 4px;
            border-radius: 4px;
            background: #323232;
            box-shadow: none;
            margin: 0 4px;
            opacity: 1;

            ${props =>
                props.isVolunteer &&
                !isPortrait() &&
                `
                    &:last-of-type {
                        display: none
                    }`};

            button {
                height: auto;
                width: 100%;
                margin-top: -3.5px;

                &:before {
                    visibility: hidden;
                    width: 100%;
                    margin-top: -8px;
                }
            }

            &.slick-active {
                background: #ff245e;
            }
        }
    }
`;
class Carousel extends React.Component {
    static propTypes = {
        activeActionIndex: PropTypes.number,
        afterChange: PropTypes.func,
        beforeChange: PropTypes.func,
        showSlider: PropTypes.bool.isRequired,
        children: PropTypes.array,
        carouselSettings: PropTypes.object,
        hover: PropTypes.bool
    };

    shouldComponentUpdate(nextProps) {
        if (this.props.activeActionIndex !== nextProps.activeActionIndex) {
            if (this.props.activeActionIndex > nextProps.activeActionIndex) {
                this._back();
                return true;
            } else {
                this._forward();
                return true;
            }
        }
        if (this.props.hover !== nextProps.hover) return true;
        return false;
    }

    _forward() {
        this.c.slickNext();
    }

    _back() {
        this.c.slickPrev();
    }

    render() {
        return (
            <CarosuelContainer {...this.props}>
                {this.props.showSlider ? (
                    <Slider
                        {...this.props.carouselSettings}
                        ref={node => (this.c = node)}
                        afterChange={this.props.afterChange}
                        beforeChange={this.props.beforeChange}
                    >
                        {this.props.children}
                    </Slider>
                ) : (
                    this.props.children
                )}
            </CarosuelContainer>
        );
    }
}

export default Carousel;
